import cv from "./../../assets/CV-Valentin-Gonzalez-Loureiro.pdf";
import vgl from "./../../assets/VGL.png";

const data = {
  personalInfo: {
    name: "Valentín González Loureiro",
    title: "Fullstack Developer - UX/UI Expert - CX Analyst - AI Developer",
    birthDate: "09/05/1998",
    location: "Buenos Aires, Argentina",
    email: "valentingonzalezlou@gmail.com",
    website: "vgl.com.ar",
  },
  summary:
    "+10 years creating exceptional digital experiences for international companies. Currently developing scalable applications at RIU Hotels & Resorts while leading my tech venture GARPAR.ar. Collaborating with UX/CX teams to translate visions and experiences into productive code. Developing reusable component libraries that accelerate delivery. Implementing accessibility and SEO best practices. Empowering processes through automation. Technical mentoring and project estimation. My unique approach combines technical expertise with business vision, from startups to multinational corporations, I translate complex needs into scalable technical solutions. Currently studying Data Science at UBA, always exploring new technologies to create the digital future.",
  experience: [
    {
      company: "RIU Hotels & Resorts",
      position: "Frontend Developer",
      period: "05/2023 - present",
      location: "Palma de Mallorca and surroundings · Remote",
      description:
        "Responsible for creating the application coding and development as defined by UX Designers. I participate in the design process as a consultant on possibilities, consume the design process output, work on it, evaluate the different scenarios and finally craft the results into reusable blocks of code using the current Frontend technology.",
      responsibilities: [
        "Create web and mobile application frontend as per designed by UX/CX team",
        "Integrate application frontend with application business layer",
        "Collect feedback from the Design and Development teams to ensure design consistency and understand teams needs to provide better output",
        "Follow best practices and standards for coding html, css, js, ensuring accessibility compatibility, developing unit tests and developing and maintaining component documentation ensuring cross browser compatibility",
        "Develop a level of design and business understanding so as to not compromise on business goals and design intents",
        "Estimate tasks efforts and collaborate on project planning",
      ],
      technologies: [
        "Angular",
        "HTML5",
        "CSS3",
        "SASS",
        "MicroFrontends",
        "RIU Library",
        "Javascript",
        "Typescript",
        "GIT",
        "OpenProyect",
        "Gitlab",
        "Jenkins",
        "Sonar",
        "Agile",
        "Scrum",
        "ServiceNow",
      ],
      type: "full-time",
    },
    {
      company: "GARPAR.ar",
      position: "Full Stack Developer | CEO & Founder",
      period: "10/2023 - present",
      location: "Argentina · Remote",
      description:
        "Own venture where I act as CEO, CTO and Full Stack Developer, leading the complete development of the platform.",
      technologies: [
        "NEXT.js",
        "HTML5",
        "CSS3",
        "SASS",
        "Storybook",
        "Typescript",
        "Tailwind",
        "Firestore",
        "Firebase",
        "GIT",
        "Vercel",
        "GitHub",
        "Supabase",
      ],
      type: "entrepreneurship",
    },
    {
      company: "Technisys",
      position: "UI Developer",
      period: "05/2022 - 05/2023",
      location: "Argentina",
      description:
        "Responsible for creating the application coding and development as defined by UX Designers. I participate in the design process as a consultant on possibilities, consume the design process output, work on it, evaluate the different scenarios and finally craft the results into reusable blocks of code using the current Frontend technology.",
      responsibilities: [
        "Create web and mobile application frontend as per designed by UX/CX team",
        "Integrate application frontend with application business layer",
        "Collect feedback from the Design and Development teams to ensure design consistency and understand teams needs to provide better output",
        "Follow best practices and standards for coding html, css, js, ensuring accessibility compatibility, developing unit tests and developing and maintaining component documentation ensuring cross browser compatibility",
        "Develop a level of design and business understanding so as to not compromise on business goals and design intents",
        "Estimate tasks efforts and collaborate on project planning",
      ],
      technologies: [
        "React.js",
        "Angular",
        "HTML5",
        "CSS3",
        "SASS",
        "Storybook",
        "Styled-components",
        "Javascript",
        "Typescript",
        "Bootstrap",
        "Tailwind",
        "GIT",
        "Jira",
        "Tempo",
        "Confluence",
        "BitBucket",
        "GitHub",
        "Agile",
        "Scrum",
      ],
      type: "full-time",
    },
    {
      company: "Colonia Express",
      position: "Full Stack Developer",
      period: "11/2021 - 05/2022",
      technologies: [
        "Angular",
        "React.js",
        "Ionic",
        "HTML5",
        "CSS3",
        "Bootstrap",
        ".NET",
        "TypeScript",
        "GIT",
        "SEO",
        "GitHub",
      ],
      description:
        "User Experience Design: Research. Workflows. UI design. Voice & Tone. Storytelling. Prototyping. Testing.",
      type: "full-time",
    },
    {
      company: "MSBroker",
      position: "Web Developer",
      period: "02/2016 - 10/2021",
      technologies: [
        "HTML5",
        "CSS3",
        "JavaScript",
        "SEO",
        "Google ADS",
        "Google Analytics",
      ],
      description:
        "User Experience Design: Research. Prototyping. Graphic design: Art design. Branding. Digital and media graphic advertising.",
      type: "full-time",
    },
  ],
  shopifyExperience: [
    {
      company: "Lindye Galloway Studio + Shop (LeMae)",
      position: "Frontend Developer",
      period: "05/2024 - present",
      location: "California, United States · Remote",
      description:
        "Responsible for e-commerce development. Ensure that these components and the overall application are robust and easy to maintain. Commitment to collaborative problem solving, sophisticated design, and quality product.",
      responsibilities: [
        "Develop new user-facing features",
        "Build reusable components",
        "Translate designs and wireframes into high-quality code, ensuring the technical feasibility of design",
        "Optimize components for maximum performance across a vast array of web-capable devices and browsers",
        "SEO analysis and optimization",
      ],
    },
    {
      company: "Huega House",
      position: "Frontend Developer",
      period: "08/2024 - present",
      location: "California, United States · Remote",
    },
    {
      company: "Samana Costa Rica",
      position: "Frontend Developer",
      period: "07/2024 - present",
      location: "Samana, Costa Rica · Remote",
    },
    {
      company: "+Beryll",
      position: "Frontend Developer",
      period: "03/2024 - 06/2024",
      location: "Malibu, California, United States · Remote",
      description:
        "Responsible for e-commerce development. Ensure that these components and the overall application are robust and easy to maintain. Commitment to collaborative problem solving, sophisticated design, and quality product.",
      responsibilities: [
        "Develop new user-facing features",
        "Build reusable components",
        "Translate designs and wireframes into high-quality code, ensuring the technical feasibility of design",
        "Optimize components for maximum performance across a vast array of web-capable devices and browsers",
        "SEO analysis and optimization",
      ],
    },
  ],
  skills: {
    frontend: [
      "Angular",
      "React.js",
      "VUE.js",
      "ASTRO",
      "Next.js",
      "Ionic",
      "HTML5",
      "CSS3",
      "SASS",
      "JavaScript",
      "TypeScript",
    ],
    styling: ["Bootstrap", "Tailwind", "shadcn", "Styled-components"],
    tools: ["Storybook", "Chromatic", "Figma", "Asana", "Atlassian"],
    testing: ["jest"],
    backend: ["Node.js", "Express", ".NET"],
    databases: [
      "MongoDB",
      "MySQL",
      "Postgres",
      "Firestore",
      "Firebase",
      "Supabase",
    ],
    versionControl: ["GIT", "GitHub", "GitLab", "BitBucket"],
    deployment: ["Vercel", "Netlify", "Jenkins"],
    ecommerce: ["Shopify Liquid"],
    projectManagement: [
      "Jira",
      "Tempo",
      "Confluence",
      "OpenProyect",
      "ServiceNow",
    ],
    methodologies: ["Agile", "Scrum"],
    analytics: ["SEO", "Google ADS", "Google Analytics"],
    quality: ["Sonar"],
    ai: [
      "Cursor dev",
      "n8n flows",
      "LLM integrations",
      "mcp",
      "Lovable",
      "Bolt",
    ],
  },
  languages: [
    {
      language: "Spanish",
      level: "Native",
    },
    {
      language: "English",
      level: "B2",
    },
  ],
  education: [
    {
      program: "Data Science",
      institution: "UBA",
      year: "2020",
      status: "Ongoing",
    },
    {
      program: "Full Stack Web Developer - Angular / Typescript",
      institution: "UNC (Ícaro)",
      year: "2021",
      status: "Completed",
    },
    {
      program: "UX/UI Design",
      institution: "Educacion IT (Digit@lers)",
      year: "2021",
      status: "Completed",
    },
    {
      program: "Full Stack Web Developer - Java",
      institution: "Codo a codo 4.0 (GCBA)",
      year: "2021",
      status: "Completed",
    },
    {
      program: "Front End Web Developer - Javascript",
      institution: "Fundación Telefónica",
      year: "2021",
      status: "Completed",
    },
  ],
};

function Cv() {
  return (
    <>
      <main className='df'>
        <div style={{ width: "100%" }}>
          <h1 className='text-center'>{data.personalInfo.name}</h1>
          <h2
            className='text-center subtitle'
            style={{ paddingBottom: "1rem" }}
          >
            {data.personalInfo.title}
          </h2>
          <p>{data.summary}</p>
          <a
            className='hover-this'
            target='_blank'
            rel='noopener noreferrer'
            href={cv}
          >
            <h3 className='download underline'>Download CV</h3>
          </a>

          <div>
            <h2 className='underline text-center'>Stack</h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
              }}
            >
              {Object.entries(data.skills).map(([cat, skills]) => (
                <div key={cat}>
                  <strong>{cat.charAt(0).toUpperCase() + cat.slice(1)}</strong>
                  <ul className='stack-list'>
                    {skills.map((s) => (
                      <li key={s}>{s}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className='underline text-center'>Education</h2>
            <div className='study-content'>
              {data.education.map((e, i) => (
                <div className='study-content-card' key={i}>
                  <h3>{e.program}</h3>
                  <h4>
                    {e.institution} - {e.year} ({e.status})
                  </h4>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className='underline text-center'>Work Experience</h2>
            <div className='job-content'>
              {data.experience.map((exp, i) => (
                <article
                  className='job-content-card'
                  key={i}
                  style={{
                    marginBottom: "2rem",
                    padding: "1.5rem 1rem",
                    background: "rgba(30,30,30,0.7)",
                    borderRadius: "10px",
                  }}
                >
                  <h2 style={{ marginBottom: "0.5rem" }}>{exp.company}</h2>
                  <h3 style={{ marginBottom: "0.5rem", fontWeight: 400 }}>
                    {exp.position}
                  </h3>
                  <p
                    className='my-4'
                    style={{ marginBottom: "0.5rem", color: "#ccc" }}
                  >
                    {exp.period}
                  </p>
                  {exp.location && (
                    <p style={{ marginBottom: "0.5rem" }}>
                      <strong>Location:</strong> {exp.location}
                    </p>
                  )}
                  <p style={{ marginBottom: "0.5rem" }}>{exp.description}</p>
                  {exp.responsibilities && (
                    <ul style={{ marginBottom: "0.5rem" }}>
                      {exp.responsibilities.map((r, idx) => (
                        <li key={idx} style={{ marginBottom: "0.25rem" }}>
                          {r}
                        </li>
                      ))}
                    </ul>
                  )}
                  <p style={{ marginBottom: 0 }}>
                    <strong>Stack:</strong> {exp.technologies.join(", ")}
                  </p>
                </article>
              ))}
            </div>
          </div>

          <div>
            <h2 className='underline text-center'>Shopify Experience</h2>
            <div className='job-content'>
              {data.shopifyExperience.map((exp, i) => (
                <article
                  className='job-content-card'
                  key={i}
                  style={{
                    marginBottom: "1rem",
                    padding: "1rem",
                    background: "rgba(30,30,30,0.7)",
                    borderRadius: "10px",
                  }}
                >
                  <h2 style={{ marginBottom: "0.5rem" }}>{exp.company}</h2>
                  {exp.location && (
                    <p style={{ marginBottom: 0, color: "#ccc" }}>
                      <strong>Location:</strong> {exp.location}
                    </p>
                  )}
                </article>
              ))}
            </div>
          </div>

          <div className='lang text-center'>
            <h2 className='underline '>Languages</h2>
            {data.languages.map((l, i) => (
              <p key={i}>
                {l.language} - {l.level}
              </p>
            ))}
          </div>
        </div>
      </main>
      <img
        loading='lazy'
        className='slide-in'
        id='VGL'
        src={vgl}
        width='200'
        alt='VGL pic'
      />
    </>
  );
}

export default Cv;
